<template>
    <div class="editform">
        <Form
            ref="dInfo"
            :model="dInfo"
            :rules="ruleValidate"
            :label-width="100"
        >
            <FormItem label="组织机构名称" prop="name">
                <Input v-model="dInfo.name" :maxlength="32"></Input>
            </FormItem>
            <FormItem label="组织机构类型" prop="orgLevel">
                <Select v-model="dInfo.orgLevel" transfer>
                    <Option
                        v-for="(item, index) in orgLevelList"
                        :value="item.id"
                        :key="index"
                    >
                        {{ item.text }}
                    </Option>
                </Select>
            </FormItem>
            <FormItem label="备注说明" prop="remark">
                <Input
                    type="textarea"
                    v-model="dInfo.remark"
                    placeholder="0/1000"
                    :rows="3"
                    :maxlength="1000"
                >
                </Input>
            </FormItem>
        </Form>
    </div>
</template>
<script>
import { orgView, orgAdd, orgUpdate } from '@/api/sys-org'
import Dict from '_u/dict'

export default {
    name: 'org-form',
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
        pid: {
            type: [String, Number],
            default: '0',
        },
    },
    components: {},
    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            dInfo: {
                id: this.id,
                pid: this.pid,
                name: '',
                orgLevel: '',
                remark: '',
                ver: '',
            },
            ruleValidate: {
                name: [
                    {
                        required: true,
                        message: '岗位名称必填',
                        trigger: 'blur',
                    },
                ],
                orgLevel: [
                    {
                        required: true,
                        message: '组织机构类型必填',
                    },
                ],
            },
            orgLevel: Dict.NULL,
            sysDisabled: false,
        }
    },
    computed: {
        orgLevelList() {
            return this.orgLevel.val()
        },
    },
    methods: {
        fetch() {
            if (this.id) {
                return orgView(this.id)
            } else {
                this.dInfo.pid = this.pid
                return Promise.resolve()
            }
        },
    },
    mounted() {
        var $dInfo = this.$refs.dInfo
        this.$modal.onBtnClick('confirm', (next, options) => {
            $dInfo.validate((valid) => {
                if (valid) {
                    if (this.id) {
                        orgUpdate(this.dInfo)
                            .then(
                                (res) => {
                                    this.$Message.success(
                                        this.$t('tips.update.success')
                                    )
                                },
                                (err) => (options.closeModal = false)
                            )
                            .then((res) => next())
                    } else {
                        orgAdd(this.dInfo)
                            .then(
                                (res) => {
                                    this.$Message.success(
                                        this.$t('tips.add.success')
                                    )
                                },
                                (err) => (options.closeModal = false)
                            )
                            .then((res) => next())
                    }
                } else {
                    options.closeModal = false
                    next()
                }
            })
        })

        // 在窗口显示前加载数据
        this.$modal.beforeEnter((next) => {
            Promise.all([this.fetch()]).then((args) => {
                var [org] = args

                if (org) {
                    var orgData = org.data

                    Object.keys(this.dInfo).forEach((name) => {
                        this.dInfo[name] = orgData[name]
                    })
                }
                next()
            })
        })
    },

    created() {
        Promise.all([Dict.get(['org_level'])]).then((args) => {
            var [dictGroup] = args
            this.dictGroup = dictGroup
            this.orgLevel = dictGroup.org_level
            return args
        })
    },
}
</script>
